/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const union_user_anchor_apply_status = createAsyncThunk(
  'Saada/saadaAnchorJoinUnion/union_user_anchor_apply_status',
  async (p: any, store: any) => {
    // return {
    //     // union_id: 1233,
    //     // union_leader_id: 3333,
    //     avatar: 'http://me-media-gateway.test03.youyisia.com/account/avatar/id/104933222/sz/228',
    // }
    const resp = await http.post(
      '/live/hiya_socialize/union_user_anchor_apply_status',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const union_submit_anchor_apply = createAsyncThunk(
  'Saada/saadaAnchorJoinUnion/union_submit_anchor_apply',
  async (p: any, store: any) => {
    // return {
    //     avatar_verified: true,
    //     union_id: 1233,
    //     union_leader_id: 3333,
    // }
    const resp = await http.post(
      '/live/hiya_socialize/union_submit_anchor_apply',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const union_check_code = createAsyncThunk(
  'Saada/saadaAnchorJoinUnion/union_check_code',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/union_check_code',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const update_v2 = createAsyncThunk(
  'Saada/saadaAnchorJoinUnion/update_v2',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/account/update_v2',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  home: {
    union_id?: number
    union_leader_id?: number
    avatar?: string
  }
  curStep: number
  code: ''
} = {
  home: {},
  curStep: 0,
  code: '',
}

export function useSaadaAnchorJoinUnion() {
  return useSelector((store) => store.SaadaAnchorJoinUnion)
}

export const SaadaAnchorJoinUnionSlice = createSlice({
  name: 'SaadaAnchorJoinUnion',
  initialState,
  reducers: {
    updateCurStep: (state, action) => {
      Object.assign(state, {
        curStep: action.payload,
      })
    },
    updateCode: (state, action) => {
      Object.assign(state, {
        code: action.payload,
      })
    },
    updateHome: (state, action) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      union_user_anchor_apply_status.fulfilled,
      (state, action) => {
        Object.assign(state.home, action.payload)
      }
    )
  },
})

export default SaadaAnchorJoinUnionSlice.reducer
export const SaadaAnchorJoinUnionActions = SaadaAnchorJoinUnionSlice.actions
